import styled from 'styled-components'

interface BoxProps {
  $area: string
  $borderLeft?: boolean
  $borderBottom?: boolean
}

const Box = styled.div<BoxProps>`
  grid-area: ${props => props.$area};
  padding: 2rem;

  border: 0px solid ${props => props.theme.colors.gray8};
  ${props => props.$borderLeft && 'border-left-width: 1px;'};
  ${props => props.$borderBottom && 'border-bottom-width: 1px;'};

  min-height: ${props => props.$area === 'reason' && '170px'};

  h4 {
    margin: 0 0 1.5rem 0;
    color: ${props => props.theme.colors.gray5};
    font-size: 1rem;
    font-weight: 600;
  }
  span {
    font-weight: 600;
    font-size: 1.6rem;
  }
  .status {
    align-items: flex-start;
    h4 {
      margin: 0 0 0.3rem;
    }
    div {
      font-size: 1.6rem;
    }
  }
  .time,
  .info {
    align-items: flex-start;
    h4 {
      margin: 0 0 0.3rem;
    }
  }
`

interface AbsenceInfoBoxProps {
  area: string
  title: string
  value?: React.ReactNode
  borderLeft?: boolean
  borderBottom?: boolean
  className?: string
}

export const AbsenceInfoBox = ({
  area,
  title,
  value,
  borderLeft,
  borderBottom,
  className,
}: AbsenceInfoBoxProps) => (
  <Box $area={area} $borderLeft={borderLeft} $borderBottom={borderBottom}>
    <div className={className ?? 'info'}>
      <h4>{title}</h4>
      {className === 'status' ? value : <span>{value}</span>}
    </div>
  </Box>
)
